export const type_webpage_procurementMatchmaking = 'procurementMatchmaking' //网页类型-采购对接会
export const type_webpage_guideVisit = 'guideVisit' //网页类型-采购
export const type_webpage_catalogDownload = 'catalogDownload' //网页类型-采购// 对接会
export const type_webpage_visitorPreRejst = 'visitorPreRejst' // 观众预登记
export const type_webpage_aboutCIOSH = 'aboutCIOSH' // 展会介绍
export const type_webpage_service = 'service' // 综合服务

export const type_webpage_zh = {
  [type_webpage_procurementMatchmaking]: "采购对接会",
  [type_webpage_guideVisit]: "参观指南",
  [type_webpage_catalogDownload]: "会刊下载",
  [type_webpage_visitorPreRejst]: "观众预登记",
  [type_webpage_aboutCIOSH]: "展会介绍",
  [type_webpage_service]: "综合服务"
}
export const liveSatusOptions = [{ value: "1", label: "直播中" },
{ value: "2", label: "已结束" },
{ value: "3", label: "暂停中" },]

export const exhibitionAreas = [
  "户内外喷绘设备及墨水专题展",
  "户内外数码喷印耗材专题展",
  "数码印花及耗材专题展",
  '激光雕刻切割设备及配件专题展',
  "标识标牌灯箱专题展",
  "亚克力及广告板材专题展",
  "数字标识专题展",
  "商业零售及展览展示专题展"
]
export const exhibitionAreasEN = [
  "Indoor & Outdoor Digital Print Equipment and Ink",
  "Indoor  Outdoor Digital Print Materials",
  "Digital Textile Printing Equipment & Materials",
  'Laser Engraving & Cutting Equipment and Components',
  "Signage & Light Box",
  "Acrylic & Advertising Panel",
  "Digital Signage",
  "Display & Retail Solution"
]


export const isShengzheng = true

export const projectId_ = process.env.VUE_APP_PROJECTID













// WEBPACK FOOTER //
// ./src/wenxing_h5/constants.js